export default __webpack_public_path__ + "static/media/LU.43fc9c2d.svg";